import * as z from "zod";

/** A pre-registered app's team access request, for its consent page. */
export const getTeamAccessRequest = {
  name: "getTeamAccessRequest" as const,
  input: z.object({
    clientId: z.string(),
    redirectUri: z.string(),
    /** OAuth scope; absent or `team` alone asks for every public API scope. */
    scope: z.string().optional(),
  }),
  output: z.object({
    appName: z.string(),
    /** A copy of the app running on the approver's own computer. */
    isDeveloperCopy: z.boolean(),
    /** The signed-in store, which approval must send back unchanged. */
    storeId: z.string(),
    /** Where the browser goes next, e.g. "ditto.redo.com". */
    redirectHost: z.string(),
    storeName: z.string(),
    /** The requested access in one line, e.g. "View and change Orders and Returns". */
    summary: z.string(),
    /** One line per area, e.g. "Orders: View, create and edit". */
    permissions: z.array(z.string()),
    /** Whether the signed-in user may approve: a current member with Manage team developer tools, signed in as themselves. */
    canApprove: z.boolean(),
  }),
};
